<div class="main-content">
  <app-header [title]="'HEADER.TITLE_BANNER' | translate" [subtitle]="'HEADER.SUBTITLE_BANNER' | translate" />

  <div class="row mt-5">
    <div class="col-12 d-flex justify-content-end">
      <button class="banner-button" [routerLink]="['/banner', 'new']" *appHasRole="['ADMIN']">
        {{ 'BANNER.CREATE_BANNER' | translate }}
      </button>
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-12">
      <app-icam-container [iconName]="'banner'" iconHeight="24px">
        <app-table
          [allValues$]="banners$"
          [type]="'banners'"
          (selectedFilter)="onSelectedFilter($event)"
          [hasChart]="false"
          [filters$]="bannerFilter$"
          (selectedPage)="onBannerPage($event)"
          [prevPage]="prevPage"
          [currentPage]="currentPage"
          [nextPage]="nextPage"
          [totalPages]="totalPages"
          [hasKeywordFilter]="true"
          [useInlineKeywordFilter]="true"
          [keywordFilterName]="'keyword'"
          [keywordFilterPlaceholder]="'FILTER.SEARCH_BANNERS'"
          [initialFilters]="bannerFilter$"
        />
      </app-icam-container>
    </div>
  </div>
</div>
